import { render, staticRenderFns } from "./Weathermap.vue?vue&type=template&id=4af38afd&"
import script from "./Weathermap.vue?vue&type=script&lang=js&"
export * from "./Weathermap.vue?vue&type=script&lang=js&"
import style0 from "./Weathermap.vue?vue&type=style&index=0&id=4af38afd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports